module.exports = __webpack_public_path__ + "img/260.4963724b.jpg";